"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiSlotSymbol = void 0;
var _pixi = require("pixi.js");
var _PixiSpineAnimation = require("./PixiSpineAnimation");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiSlotSymbol = exports.PixiSlotSymbol = /*#__PURE__*/function (_Container) {
  function PixiSlotSymbol(reelIndex, symbolIndex, symbolWidth, symbolHeight) {
    var _this;
    _classCallCheck(this, PixiSlotSymbol);
    _this = _callSuper(this, PixiSlotSymbol);
    _defineProperty(_this, "symbolID", 0);
    _defineProperty(_this, "symbol", void 0);
    _defineProperty(_this, "_symbolAnimationContainer", void 0);
    /**
     * The cells position in coordinates within the reel container.
     */
    _defineProperty(_this, "effectsPosition", void 0);
    _defineProperty(_this, "r", void 0);
    _defineProperty(_this, "s", void 0);
    _defineProperty(_this, "symbolAnimation", void 0);
    _defineProperty(_this, "_symbolWidth", void 0);
    _defineProperty(_this, "_symbolHeight", void 0);
    /**
     * Symbol should not spin.
     * Used for things like sticky wilds. etc.
     * Note. this is not used on reel games since we need to place a new symbol on top of the old one. to give the full spin effect.
     */
    _defineProperty(_this, "sticky", false);
    _this.r = reelIndex;
    _this.s = symbolIndex;
    _this.name = 'r' + reelIndex + 's' + symbolIndex;
    _this._symbolWidth = symbolWidth;
    _this._symbolHeight = symbolHeight;
    _this.symbol = new _pixi.Sprite();
    _this.symbol.anchor.set(0.5);
    _this.symbol.x = _this._symbolWidth / 2;
    _this.symbol.y = _this._symbolHeight / 2;
    _this._symbolAnimationContainer = new _pixi.Container();
    _this._symbolAnimationContainer.name = "SymbolAnimationContainer";
    _this.addChild(_this.symbol, _this._symbolAnimationContainer);
    return _this;
  }
  _inherits(PixiSlotSymbol, _Container);
  return _createClass(PixiSlotSymbol, [{
    key: "paintDebug",
    value: function paintDebug() {

      /*  var graphics = new PIXI.Graphics();
       graphics.beginFill(0xFFFF00);
            // set the line style to have a width of 5 and set the color to red
      //graphics.lineStyle(5, 0xFF0000);
            // draw a rectangle
      graphics.drawRect(0, 0, layout.symbolWidth, layout.symbolHeight);
            this.addChild(graphics);*/
      /*  let sp = new Sprite(Texture.from('centerspot'))
      sp.name = 'centerspot'
      sp.zIndex = 1000
      sp.anchor.set(0.5)
      this.addChild(sp)
      sp.x = layout.symbolWidth / 2
      sp.y = layout.symbolHeight / 2*/
    }
  }, {
    key: "onWin",
    value: function onWin(quickStop, freeSpin, reSpin) {}
  }, {
    key: "onSpinStart",
    value: function onSpinStart(isFreeSpin, isReSpin) {}
  }, {
    key: "onSpinFullSpeed",
    value: function onSpinFullSpeed(isFreeSpin) {}
  }, {
    key: "onSpinStop",
    value: function onSpinStop(quickStop, freeSpin, reSpin) {}
  }, {
    key: "onSpinUp",
    value: function onSpinUp(freespin) {}
  }, {
    key: "onSpinDown",
    value: function onSpinDown(quickStop, freespin) {}
  }, {
    key: "onFullStop",
    value: function onFullStop(quickStop, freespin) {}
  }, {
    key: "updateSymbol",
    value:
    /**
     * Set the symbol that should be shown.
     * @param symbolID 
     * @param blurred 
     * @param expanded 
     */
    function updateSymbol(symbolID, blurred) {
      this.clearAnimation();
      if (blurred) this.symbol.texture = _pixi.Texture.from('b' + symbolID + '.png');else this.symbol.texture = _pixi.Texture.from('s' + symbolID + '.png');
      this.symbol.visible = true;
      this.symbolID = symbolID;
      // higher symbols shown on top of lower by default.
      this._zIndex = symbolID;
    }
  }, {
    key: "darken",
    value: function darken() {
      this.symbol.texture = _pixi.Texture.from('d' + this.symbolID + '.png');
      this.symbol.visible = true;
      if (this.symbolAnimation) {
        this.symbolAnimation.renderable = false;
      }
    }
  }, {
    key: "lighten",
    value: function lighten() {
      this.symbol.texture = _pixi.Texture.from('s' + this.symbolID + '.png');
      if (this.symbolAnimation) {
        this.symbolAnimation.renderable = true;
        this.symbol.visible = false;
      }
    }
  }, {
    key: "playAnimation",
    value: function playAnimation(skeletonName, animationName) {
      var loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var skin = arguments.length > 3 ? arguments[3] : undefined;
      // do this with auto play stuff so null/undefined can be passed here.
      if (!skeletonName || !animationName) return;
      if (this.symbol) this.symbol.visible = false;

      // if there is no animation, we need to create one.
      if (!this.symbolAnimation) {
        this.symbolAnimation = new _PixiSpineAnimation.PixiSpineAnimation(skeletonName);
        this._symbolAnimationContainer.addChild(this.symbolAnimation);
      }
      if (skin) this.symbolAnimation.skeleton.setSkinByName(skin);
      this.symbolAnimation.x = this._symbolWidth / 2;
      this.symbolAnimation.y = this._symbolHeight / 2;
      this.symbolAnimation.state.setAnimation(0, animationName, loop);
    }
  }, {
    key: "playAnimationAsync",
    value: function playAnimationAsync(skeletonName, animationName, delay, skin) {
      var _this2 = this;
      var track = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      // do this with auto play stuff so null/undefined can be passed here.
      if (!skeletonName || !animationName) return;
      if (this.symbol) {
        if (delay > 0) {
          setTimeout(function () {
            _this2.symbol.visible = false;
          }, delay);
        } else this.symbol.visible = false;
      }

      // if there is no animation already, we need to create one.
      if (!this.symbolAnimation) {
        this.symbolAnimation = new _PixiSpineAnimation.PixiSpineAnimation(skeletonName);
        this._symbolAnimationContainer.addChild(this.symbolAnimation);
      }
      this.symbolAnimation.x = this._symbolWidth / 2;
      this.symbolAnimation.y = this._symbolHeight / 2;
      if (skin) this.symbolAnimation.skeleton.setSkinByName(skin);

      //  console.log('PixiSlotSymbol playAnimationAsync', track, animationName, delay)

      return this.symbolAnimation.playAnimationAsync(track, animationName, delay);
    }
  }, {
    key: "addAnimation",
    value: function addAnimation(skeletonName, animationName, delay, skin) {
      var _this3 = this;
      var track = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var loop = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      // do this with auto play stuff so null/undefined can be passed here.
      if (!skeletonName || !animationName) return;
      if (this.symbol) {
        if (delay > 0) {
          setTimeout(function () {
            _this3.symbol.visible = false;
          }, delay);
        } else this.symbol.visible = false;
      }

      // if there is no animation already, we need to create one.
      if (!this.symbolAnimation) {
        this.symbolAnimation = new _PixiSpineAnimation.PixiSpineAnimation(skeletonName);
        this._symbolAnimationContainer.addChild(this.symbolAnimation);
      }
      this.symbolAnimation.x = this._symbolWidth / 2;
      this.symbolAnimation.y = this._symbolHeight / 2;
      if (skin) this.symbolAnimation.skeleton.setSkinByName(skin);
      return this.symbolAnimation.addAnimation(track, animationName, loop, delay);
    }
  }, {
    key: "clearAnimation",
    value: function clearAnimation() {
      if (this.symbolAnimation) {
        var _this$symbolAnimation, _this$symbolAnimation2;
        this.symbolAnimation.renderable = false;
        (_this$symbolAnimation = this.symbolAnimation.state) === null || _this$symbolAnimation === void 0 || _this$symbolAnimation.clearTrack(0);
        (_this$symbolAnimation2 = this.symbolAnimation.skeleton) === null || _this$symbolAnimation2 === void 0 || _this$symbolAnimation2.setToSetupPose();
        // this is very important to clear the Animation for removal.
        this.symbolAnimation.destroy({
          children: true
        });
      }
      delete this.symbolAnimation;
      this.symbolAnimation = undefined;
      if (this._symbolAnimationContainer.children.length > 0) {
        var children = this._symbolAnimationContainer.children;
        this._symbolAnimationContainer.removeChildren();
        for (var i in children) {
          children[i].destroy();
        }
      }
    }
  }, {
    key: "idle",
    value: function idle() {}
  }, {
    key: "anticipating",
    value: function anticipating() {}
  }]);
}(_pixi.Container);
//# sourceMappingURL=PixiSlotSymbol.js.map